import ApplicationSerializer from './application';

export default class MapFloorSerializer extends ApplicationSerializer {
  attrs = {
    rasterImageUrl: {
      serialize: false,
    },
  };
}
